export default __webpack_public_path__ + "static/media/qgis.11b75e83.png";